document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".premium-mega-menu").forEach((menu) => {

        const items = menu.querySelectorAll(".premium-sidebar-item");
        const panels = menu.querySelectorAll(".premium-panel");

        if (!items.length || !panels.length) return;

        function activate(target) {

            items.forEach(item => item.classList.remove("active"));
            panels.forEach(panel => panel.classList.remove("active"));

            target.classList.add("active");

            const id = target.dataset.menu;

            const panel = menu.querySelector("#" + id);

            if (panel) {
                panel.classList.add("active");
            }
        }

        // First active
        activate(items[0]);

        // Desktop Hover
        items.forEach(item => {

            item.addEventListener("mouseenter", () => {

                if (window.innerWidth > 991) {
                    activate(item);
                }

            });

        });

        // Mobile Click
        items.forEach(item => {

            item.addEventListener("click", function (e) {

                if (window.innerWidth <= 991) {

                    e.preventDefault();

                    activate(this);

                }

            });

        });

    });

});